<template>
    <div>
        {{ productName(item) }}
        <v-menu
            open-on-hover
            top
            offset-y
            :min-width="840"
        >
            <template #activator="{on}">
                <v-btn v-on="on" icon small>
                    <v-icon>mdi-cogs</v-icon>
                </v-btn>
            </template>
            
            <v-card>
                <v-card-title>Build values</v-card-title>
                <v-row no-gutters>
                    <v-col cols="4">
                        <template v-if="head">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <td colspan="2" class="text-left green lighten-5">Head</td>
                                        </tr>
                                        <tr>
                                            <th class="text-left green lighten-5">
                                            Attribute
                                            </th>
                                            <th class="text-left green lighten-5">
                                            Value
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(value, attribute) in head.options" :key="`options_head_${attribute}`">
                                            <td class="text-left green lighten-5">{{ attribute }}</td>
                                            <td class="text-left green lighten-5">{{ value }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                    </v-col>
                    <v-col cols="4">
                        <template v-if="shaft">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <td colspan="2" class="text-left cyan lighten-5">Shaft</td>
                                        </tr>
                                        <tr>
                                            <th class="text-left cyan lighten-5">
                                            Attribute
                                            </th>
                                            <th class="text-left cyan lighten-5">
                                            Value
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(value, attribute) in shaft.options" :key="`options_head_${attribute}`">
                                            <td class="text-left cyan lighten-5">{{ attribute }}</td>
                                            <td class="text-left cyan lighten-5">{{ value }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                    </v-col>
                    <v-col cols="4">
                        <template v-if="grip">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>

                                        <tr>
                                            <td colspan="2" class="text-left orange lighten-5">Grip</td>
                                        </tr>
                                        <tr>
                                            <th class="text-left orange lighten-5">Attribute</th>
                                            <th class="text-left orange lighten-5">Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(attribute, value) in grip.options" :key="`options_head_${attribute}`">
                                            <td class="text-left orange lighten-5">{{ attribute }}</td>
                                            <td class="text-left orange lighten-5">{{ value }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                    </v-col>
                </v-row>
                
                
            </v-card>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'CustomProduct',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed:{
        head () {
            return this.item.custom.products.find(p => p.type=='head')
        },
        shaft () {
            return this.item.custom.products.find(p => p.type=='shaft')
        },
        grip () {
            return this.item.custom.products.find(p => p.type=='grip')
        }
    },
    methods:{
        productName: (item) => {
            const name = item.custom?.products.map(p => p.product.name)
            return (name != null) ? name.join(' - ') : ''
        }
    }
}
</script>